import {
  Directive,
  ElementRef,
  Renderer2
} from '@angular/core';


@Directive({
  selector: '[base]'
})
export class BaseDirective {

  constructor(public elementRef: ElementRef, private renderer: Renderer2) { }

  protected setClassName(className: string) {
    this.renderer.addClass(this.elementRef.nativeElement, className);
  }

  protected removeClassName(className: string) {
    this.renderer.removeClass(this.elementRef.nativeElement, className);
  }

}
